import { IBar, IScoreEditorThis, TClef } from "../../../../../common/types";

export function handleRemoveVoice(this: IScoreEditorThis, index: number) {
  const score = { ...this.state.score };
  let { activeVoice } = this.state;
  delete score["bars" + (index || "")];
  delete score["clef" + (index || "")];
  delete score["octave" + index];
  for (let v = index + 1; v < 6; v++) {
      const voice = score["bars" + v] as IBar[];
      const clef = score["clef" + v] as TClef;
      const octave: number = score["octave" + v];
      if (voice) {
          score["bars" + (v - 1 || "")] = voice;
          delete score["bars" + v];
          score["clef" + (v - 1 || "")] = clef;
          delete score["clef" + v];
          score["octave" + (v - 1 || "")] = octave;
          delete score["octave" + v];
      }
  }
  if (!score["bars" + (activeVoice || "")]) {
      activeVoice--;
  }
  this.setState({ score, activeVoice });
}